import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import {
  demoteTransientTimeout,
  isNonActionableHttpNetworkError,
  isPreviewHostError,
  isThirdPartyClarityError,
  resolveSentryEnvironment,
} from './app/util/sentry-event-filter';
import { environment } from './environments/environment';

const isLocalEnvironment = environment.environment === 'local';

if (!isLocalEnvironment) {
  const sentryEnvironment = resolveSentryEnvironment(environment.environment);
  Sentry.init({
    dsn: 'https://d115ff59e7536b96f98d5a561d7598f3@o4508261198987264.ingest.us.sentry.io/4508263671988224',
    integrations: [Sentry.browserTracingIntegration()],
    environment: sentryEnvironment,
    release: `nnb-angular@${environment.version}`,
    tracesSampleRate: 0.001,
    tracePropagationTargets: [environment.apiDomain],
    sendDefaultPii: true,
    beforeSend(event, hint) {
      if (isNonActionableHttpNetworkError(event, hint)) {
        return null;
      }
      if (isThirdPartyClarityError(event, hint)) {
        return null;
      }
      if (isPreviewHostError(event, hint)) {
        return null;
      }
      demoteTransientTimeout(event, hint);
      return event;
    },
  });
  console.log(`Sentry initialized for environment: ${sentryEnvironment}`);
} else {
  console.log('Sentry disabled in local environment');
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
